import "./assessment_viewer.js";

// When a user clicks an assessment component, open an assessment viewer modal for them
jQuery(document).on("click", "[data-assessment]", function () {
  const assessment = jQuery(this).data("assessment");
  const form_component_uuid = jQuery(this).attr("data-uuid");

  // We don't always want to initialize component interaction, e.g. in page builder
  if (assessment) {
    return AssessmentModal.show(assessment, form_component_uuid);
  }
});

window.AssessmentModal = {
  show(assessment, form_component_uuid) {
    return jQuery.when().then(() => {
      const container = jQuery('<div id="assessment_viewer"></div>');

      const modal = new Modal({
        class: "assessment-modal",
        header: '<span class="modal-header__text">' + assessment.title + "</span>",
        freezeScroll: true,
        body: container,
        clickOut: false,
      });

      jQuery(modal).on("beforeShow", () => {
        const viewer = new AssessmentViewer(container, assessment, {
          data: {
            sourceId: window.RESOURCE.id,
            sourceType: window.RESOURCE.type,
            sourceUrl: window.location.toString(),
            form_component_uuid,
          },
        });
        return jQuery(viewer.el).on(AssessmentViewer.Events.AssessmentNavigation.endClicked, () => modal.hide());
      });

      jQuery(modal).on("hide", () => modal.destroy());
      return modal.show();
    });
  },
};
